import { render, staticRenderFns } from "./ConditionsAndDisclaimerTreatment.vue?vue&type=template&id=4b909e6b&"
import script from "./ConditionsAndDisclaimerTreatment.vue?vue&type=script&lang=js&"
export * from "./ConditionsAndDisclaimerTreatment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports